import React, { useState } from 'react'
import { Col, Row, Table } from 'reactstrap';
import Pagination from "react-js-pagination";
import { Link } from 'react-router-dom';
import { PaginatedTableProps } from './types';

// sorting value
const toggle = function(sort){ 
    return sort === 'asc' ? 'desc' : 'asc' 
  };

const PaginatedTable: React.FC<PaginatedTableProps> = ({tableHead, children, isAddButton, to, buttonText, pagination, updateFilter = () => {}, filters = {
  page: 1,
  limit: 10,
  keyword: "",
  sort: "id",
  order: "desc",
}, isAddModal, onAddClick, customButton}) => {
    
    const { current_page, last_page, per_page, total } = pagination;
    const [search, setSearch] = useState(filters.keyword || "");
    const setPage = (page) => updateFilter("page", page);
    const setLimit = (limit) => updateFilter("limit", limit);
    
    const onSortClick = (item) => {
      if (item?.isSortable) {
          const sort_value = (item.key === currentSort.sort_column) ? toggle(currentSort.sort) : "asc";
          updateFilter("sort", item.key);
          updateFilter("order", sort_value);
      }
    };

    const currentSort = {sort_column: filters.sort || "id",sort: filters.order || "desc"};
    
    const handleSearch = () => {
      updateFilter("keyword", search);
      updateFilter("page", 1); // Reset to page 1 on search
    };
    
    const handleClearSearch = () => {
      setSearch("");
      updateFilter("keyword", "");
      updateFilter("page", 1);
    };
    // const [isFiltersOpen, setIsFilterOpen] = useState<boolean>(true); 

    // const handleFilterChange = (key, value) => {
    //     updateFilter(key, value);
    //     setPage(1);
    //     if (onFilterChange) {
    //         onFilterChange(key, value);
    //     }
    // };

  return (
    <div className="table-responsive">
      {/* Top content */}
      <div className="overflow-hidden">
        <Row>
          {/* Pagination */}
          <Col md={2} sm={4} className="pagination-column">
            <div className="mb-2">
              <select className="form-select pageSize" value={filters.limit} onChange={(event) => { setLimit(parseInt(event.target.value)); setPage(1) }}>
                <option value={10}>10</option>
                {/* <option value={2}>2</option> */}
                <option value={25}>25</option>
                <option value={50}>50</option>
                <option value={100}>100</option>
              </select>
            </div>
          </Col>
          {/* search */}
          <Col sm={4} className="search-column">
          <form onSubmit={e => { e.preventDefault(); handleSearch(); }} className="app-search mb-2 p-0">
              <div className="form-group m-0">
                <div className="input-group">
                  <input
                    type="text"
                    value={search}
                    onChange={e => setSearch(e.target.value)}
                    className="form-control bg-footer-grey"
                    placeholder="Search..."
                  />
                  <div className="input-group-append">
                    <button className="btn btn-primary search-button" type="button" onClick={handleSearch}>
                      <i className="mdi mdi-magnify" />
                    </button>
                    {search && <button
                      className="btn btn-danger ms-2"
                      type="button"
                      onClick={handleClearSearch}
                    >
                      <i className="mdi mdi-close" />
                    </button>}
                  </div>
                </div>
              </div>
            </form>
          </Col>

          {/* Add new button */}
          {isAddButton &&
            <Col md={6} sm={4} className="add-button-column">
              <div className="text-sm-end text-end mb-2 ">
                <Link to= {to || ''} className= "btn btn-primary"><i className="mdi mdi-plus me-1"></i>{buttonText || "Add New"}</Link>
              </div>
            </Col>
          }
          {isAddModal &&
            <Col md={6} sm={4} className="add-button-column">
              <div className="text-sm-end text-end mb-2">
                <button className= "btn btn-primary" onClick={onAddClick}><i className="mdi mdi-plus me-1"></i>{buttonText || "Add New"}</button>
              </div>
            </Col>
          }
          {customButton && 
          <Col md={6} sm={4} className="add-button-column">
            <div className="text-sm-end text-end mb-2 ">{customButton}</div>
          </Col>
          }
        </Row>

        {/* Filters */}
        {/* {hasFilter && 
        <>
          <div className="d-flex justify-content-end d-md-none mb-2">
            <button 
              onClick={() => {setIsFilterOpen(prev => !prev)}} 
              className="btn btn-primary w-auto"

            ><i className="bx bx-filter-alt"/></button>
          </div>
          <Collapse isOpen={isFiltersOpen}>
            <Row>
                {filterValues?.map((filter: any) => (
                  <Col md={2} sm={4} key={filter.key} className="">
                    <div className="mb-2">
                      <select
                        className="form-select"
                        value={filters[filter.key] || ''}
                        onChange={e => handleFilterChange(filter.key, e.target.value)}
                      >
                        <option value=''>{filter.placeholder || `All ${filter.label}`}</option>
                        {filter.options?.map(option => (
                          <option value={`${option.value}`}  key={option.value}>{option.label}</option>
                        ))}
                      </select>
                    </div>
                  </Col>
                ))}
                  
            </Row>
          </Collapse>
        </>
        } */}
          
      </div>

      {/* Main content */}
      <div className="table-responsive mt-4">
          <Table hover className="align-middle table-nowrap w-100 dataTable no-footer dtr-inline ">
              <thead className={`table-light`}>
              <tr>
                  {tableHead?.map(item =>  
                  <th 
                  key={`key_${item.id}`} onClick={() => onSortClick(item)} role={item.isSortable ? "button" : undefined}
                  >
                  <div className="d-flex">
                  <span className="my-auto">{item.name}</span>
                  {item.isSortable && (
                      <button className="sort-indicator my-auto">
                      <span className={`upper mb-1 ${currentSort.sort_column === item.key && currentSort.sort === 'asc' ? 'opacity-100' : 'opacity-25'}`}></span>
                      <span className={`lower ${currentSort.sort_column === item.key && currentSort.sort === 'desc' ? 'opacity-100' : 'opacity-25'}`}></span>
                      </button>
                  )}
                  </div>
                  </th>
                  )}
              </tr>
              </thead>
              <tbody className='content-wrapper'>
                  {children}
              </tbody>
          </Table>
      </div>

      {/* Bottom Pagination */}
      <div className="overflow-hidden">
        <Row>
          <Col md={4}>
            <span className="my-auto dataTables_info">
              Showing {current_page !== last_page ? current_page * per_page : total} of {total} records
            </span>
          </Col>
          <Col md={8}>
            <div className="dataTables_paginate paging_simple_numbers pagination-rounded">
              <Pagination
                totalItemsCount={total}
                activePage={current_page}
                itemsCountPerPage={per_page}
                pageRangeDisplayed={3}
                prevPageText="<"
                nextPageText=">"
                firstPageText="<<"
                lastPageText=">>"
                onChange={(page) => { setPage(page); }}
                itemClass="page-item"
                linkClass="page-link"
              />
            </div>
          </Col>
        </Row>
      </div>
    </div>
  )
}

export default PaginatedTable
